import { Typography } from '@/ui/atoms/typography/Typography'
import { AlertTriangle } from 'lucide-react'
import { cn } from '@/ui/utils/style'

interface UnsupportedDebtWarningProps {
  /** Override the default message */
  message?: string
  /** Compact variant uses smaller text/padding (e.g. inside a button row) */
  compact?: boolean
  className?: string
}

const DEFAULT_MESSAGE =
  'This position has debt in a vault not supported by the card solver. Please choose a different position or create a new one.'

/**
 * Shared warning banner shown when an Euler position has debt in an unsupported vault.
 * Used in AddCardWizard, SolverChangeFlow, CardConfiguration, and ConfigureTab.
 */
export function UnsupportedDebtWarning({ message, compact = false, className }: UnsupportedDebtWarningProps) {
  return (
    <div
      className={cn('min-w-0 rounded-lg border border-red-500/20 bg-red-500/10', compact ? 'p-2' : 'p-3', className)}
    >
      <div className="flex min-w-0 items-start gap-2">
        <AlertTriangle className={cn('mt-0.5 shrink-0 text-red-400', compact ? 'h-3.5 w-3.5' : 'h-4 w-4')} />
        {compact ? (
          <span className="break-words text-red-300 text-xs">{message ?? DEFAULT_MESSAGE}</span>
        ) : (
          <Typography variant="p" className="break-words text-red-300 text-sm">
            {message ?? DEFAULT_MESSAGE}
          </Typography>
        )}
      </div>
    </div>
  )
}
